var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_event_form_newTitle"),
      widthClass: "max-1000",
      pad: "0",
      initData: _vm.eventData,
      checkData: [
        "event_business_name",
        "event_business_code",
        "event_business_description",
        "start_utc_time",
        "end_utc_time",
        "event_type_uuid",
        "event_property_group_uuid",
        "remarks",
      ],
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Stepper", {
              attrs: { curStep: _vm.curStep, items: _vm.stepper },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            { attrs: { align: "center", justify: "start" } },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_event_form_eventTypeLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.EventType,
                                      "item-text": "event_type_name",
                                      "item-value": "uuid",
                                      "single-line": "",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      "menu-props": {
                                        offsetY: true,
                                        transition: "slide-y-transition",
                                        rounded: true,
                                        contentClass: "elevation-4",
                                      },
                                      filled: "",
                                      label: _vm.$t(
                                        "label_essweb_event_form_eventTypeLabel"
                                      ),
                                      dense: "",
                                    },
                                    on: { change: _vm.onTypeChange },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.eventData.event_type_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.eventData,
                                          "event_type_uuid",
                                          $$v
                                        )
                                      },
                                      expression: "eventData.event_type_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      bindData:
                                        _vm.eventData.event_business_name,
                                      maxlength: "100",
                                      label: _vm.$t(
                                        "label_essweb_event_form_eventNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.eventData.event_business_name =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      maxlength: "20",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_ClaimReason_form_codeLabel"
                                      ),
                                    },
                                    model: {
                                      value: _vm.eventData.event_business_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.eventData,
                                          "event_business_code",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "eventData.event_business_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      bindData:
                                        _vm.eventData
                                          .event_business_description,
                                      maxlength: "500",
                                      label: _vm.$t(
                                        "label_essweb_event_form_eventDescriptionLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.eventData.event_business_description =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("TimePicker", {
                                    attrs: {
                                      isRequire: "",
                                      showDay: "",
                                      value: _vm.eventData.start_utc_time,
                                      defaultTime: _vm.eventData.start_utc_time,
                                      max: _vm.eventData.end_utc_time,
                                      placeholder: "00:00",
                                      label: _vm.$t(
                                        "label_essweb_event_form_eventStartTimeLbel"
                                      ),
                                    },
                                    on: {
                                      change: function (time) {
                                        _vm.eventData.start_utc_time = time
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("TimePicker", {
                                    attrs: {
                                      isRequire: "",
                                      isEnd: "",
                                      showDay: "",
                                      min: _vm.eventData.start_utc_time,
                                      value: _vm.eventData.end_utc_time,
                                      defaultTime: _vm.eventData.end_utc_time,
                                      placeholder: "00:00",
                                      label: _vm.$t(
                                        "label_essweb_event_form_eventEndTimeLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (time) {
                                        _vm.eventData.end_utc_time = time
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "mt-n5",
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_event_form_timeZoneLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.staticZone,
                                      "item-text": "text",
                                      "item-value": "utc",
                                      dense: "",
                                      "menu-props": {
                                        offsetY: true,
                                        transition: "slide-y-transition",
                                        rounded: true,
                                        contentClass: "elevation-4",
                                      },
                                      "single-line": "",
                                      placeholder: _vm.$t(
                                        "label_essweb_event_form_timeZoneLabel"
                                      ),
                                      filled: "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.eventData.end_time_time_zone,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.eventData,
                                          "end_time_time_zone",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "eventData.end_time_time_zone",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form2", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "flex-column",
                              attrs: { align: "center", justify: "start" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_event_form_eventPropertyGroupLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.EventGroup,
                                      "item-text": "event_property_group_name",
                                      "item-value": "uuid",
                                      "single-line": "",
                                      "menu-props": {
                                        offsetY: true,
                                        transition: "slide-y-transition",
                                        rounded: true,
                                        contentClass: "elevation-4",
                                      },
                                      filled: "",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_event_form_eventPropertyGroupLabel"
                                      ),
                                      dense: "",
                                    },
                                    on: { change: _vm.onGroupChange },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value:
                                        _vm.eventData.event_property_group_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.eventData,
                                          "event_property_group_uuid",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "eventData.event_property_group_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _vm.desserts.length
                                    ? _c("PropertyList", {
                                        attrs: {
                                          items: _vm.desserts,
                                          listdata: _vm.PropertyListData,
                                          canEdit: false,
                                        },
                                        on: {
                                          view: function (obj) {
                                            _vm.viewProperty = true
                                            _vm.toEditProperty(obj)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: {
                newBtn:
                  _vm.stepper.length == _vm.curStep && _vm.curStep != 0
                    ? true
                    : false,
                step: _vm.stepper.length == _vm.curStep ? false : true,
                preStep: _vm.curStep > 1 ? true : false,
              },
              on: {
                next: _vm.toNext,
                pre: function ($event) {
                  _vm.curStep = _vm.curStep - 1
                },
                new: _vm.toAddEvent,
                cancel: function ($event) {
                  return _vm.$toBack(_vm.isChanged)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("EditMappingPopup2", {
              attrs: {
                show: _vm.showMappingPopup,
                PropertyData: _vm.PropertyData,
                curGroupId: _vm.eventData.event_property_group_uuid,
                view: _vm.viewProperty,
              },
              on: {
                close: function ($event) {
                  _vm.showMappingPopup = false
                  _vm.PropertyData = null
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }